<template>
  <v-card class="c dashboard-stream">
    <v-card-title>
      <h3 class="headline">Stream</h3>
      <div class="new-indicator" :class="{'is-pulsing': newItem}"></div>
    </v-card-title>
    <v-card-text>
      <v-list two-line subheader>
        <v-subheader>Heute</v-subheader>
        <empty-state v-show="data.length === 0">
          <p v-if="data.length === 0" class="text-xs-center">Keine Parkvorgänge</p>
        </empty-state>
        <v-list-tile
          :to="`parking_lot/${item.parking_lot.id}`"
          v-for="item in data"
          :key="JSON.stringify(item)"
          :color="item.type"
          ripple
        >
          <v-list-tile-avatar style="font-weight: bold">
            {{ item.time }}
          </v-list-tile-avatar>
          <v-list-tile-content v-if="item.meta === 'parking_space_changed'">
            <v-list-tile-title>Ein Parkplatz wurde {{ item.newVal ? 'frei' : 'belegt' }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ item.parking_lot.name }}</v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-content v-if="item.meta === 'parking_space_time_exceeded'">
            <v-list-tile-title>Die Parkdauer wurde überschritten</v-list-tile-title>
            <v-list-tile-sub-title>{{ item.parking_lot.name }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Stream',

  props: {
    data: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      newItem: false,
    };
  },

  watch: {
    data() {
      this.newItem = true;
      setTimeout(() => {
        const el = this.$el.querySelector('.v-list__tile');
        el.style.backgroundColor = 'rgba(0,0,0,.16)';
        el.style.borderRadius = '4px';
        setTimeout(() => {
          el.style.backgroundColor = 'unset';
          el.style.borderRadius = '0';
        }, 2750);
      }, 50);
      setTimeout(() => {
        this.newItem = false;
      }, 2800);
    },
  },
};
</script>
